var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    width: "48px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#1A1A1A;}\r\n\t.st2{display:inline;}\r\n\t.st3{fill:#1A1A1A;}\r\n\t.st4{display:none;fill:#1A1A1A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M35.33,31.27c0.74,0.49,0.96,1.49,0.49,2.24c-0.23,0.36-0.52,0.75-0.87,1.1c-0.59,0.59-1.41,1.18-2.04,1.6 c-0.65,0.43-1.23,0.96-1.72,1.56l-0.08,0.1c-0.28,0.34-0.78,0.36-1.09,0.05l-4-4c-0.29-0.29-0.29-0.75,0-1.04l0.22-0.22 c0.14-0.14,0.12-0.36-0.02-0.48c-0.78-0.63-3.02-2.42-3.99-3.01c-1.19-0.72-3.43-2.17-5.01-4.05c-1.58-1.89-3.58-4.83-4.25-5.98 c-0.38-0.66-0.79-1.52-1.06-2.15c-0.19-0.43,0.03-0.93,0.47-1.09l0.02-0.01c0.89-0.32,1.89-0.12,2.58,0.52 c0.69,0.63,1.5,1.39,1.89,1.77c0.74,0.74,2.3,2.69,4.96,3.36c1.51,0.38,4.18,0.69,6.22,0.89c1.35,0.13,2.33,1.3,2.29,2.66 c-0.03,1.14,0.22,2.44,1.27,3.37C32.92,29.6,34.35,30.61,35.33,31.27z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.06,5.69c-10.54,0-19.12,8.58-19.12,19.12s8.58,19.12,19.12,19.12c10.54,0,19.12-8.58,19.12-19.12 S34.6,5.69,24.06,5.69z M24.06,40.86C15.2,40.86,8,33.66,8,24.81S15.2,8.75,24.06,8.75c8.85,0,16.06,7.2,16.06,16.06 S32.91,40.86,24.06,40.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.83,24.81c0-4.6,1.63-9.07,4.6-12.59c0.49-0.58,0.45-1.42-0.1-1.98C7.75,9.66,6.71,9.7,6.18,10.33 c-3.41,4.05-5.29,9.2-5.29,14.48s1.88,10.43,5.29,14.48c0.28,0.33,0.68,0.52,1.11,0.52c0.39,0,0.76-0.15,1.05-0.44 c0.54-0.54,0.57-1.38,0.08-1.96C5.46,33.87,3.83,29.4,3.83,24.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.93,10.33c-0.53-0.63-1.55-0.69-2.16-0.07c-0.54,0.54-0.57,1.38-0.08,1.96c2.97,3.52,4.6,8,4.6,12.59 c0,4.6-1.63,9.07-4.6,12.59c-0.49,0.58-0.45,1.42,0.1,1.98c0.28,0.28,0.64,0.43,1.03,0.43c0.43,0,0.84-0.19,1.11-0.52 c3.41-4.05,5.29-9.2,5.29-14.48C47.22,19.52,45.34,14.38,41.93,10.33z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg37);
export default __webpack_public_path__ + "static/media/37.30210f8c194497d1ba33f6e601368917.svg";
export { ForwardRef as ReactComponent };